import { Box, Tabs } from "@mui/material";
import React from "react";
import CustomTab from "./CustomTab";

interface Props {
  labels: {
    label: string;
  }[];
}

export default function CustomTopTabbar({ labels }: Props) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        width: "100%",
        // border: "1px solid gray",
        "& .MuiTabs-root": {
          minWidth: "100%",
          flexDirection: "row-reverse",
          opacity: 1,
        },
        "& .MuiButtonBase-root": {
          width: "fit-content",
          paddingX: "6px",
        },
      }}
    >
      <Tabs
        style={{
          direction: "rtl",
          display: "flex",

          // border: "1px solid gray",
        }}
        sx={{
          "& .MuiTabs-root": {
            minWidth: "100% !important",
            direction: "ltr",
            gap: "20px",
            "& .MuiTabs-flexContainer": {
              gap: "20px",
            },

            // minHeight: "fit-content !important",
          },
        }}
        scrollButtons={false}
        value={value}
        onChange={handleChange}
        variant="scrollable"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
      >
        {labels.map((item, index) => (
          <CustomTab
            handleChangeTab={(index) => setValue(index)}
            index={index}
            label={item.label}
          />
        ))}

        {/* <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={1}
          label="کارن‌کلاب"
        />
        <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={2}
          label="اطلاعیه"
        />
        <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={3}
          label="اطلاعیه"
        />
        <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={4}
          label="اطلاعیه"
        /> */}
      </Tabs>
    </Box>
  );
}
